import PropTypes from 'prop-types';
import React from 'react';

import Util from '$utilities';
import { Header, Footer, SideLine, Background } from '$partials/global/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ErrorPage = (props) => {
    const status = Util.try(() => props.err.status) || 500;

    const page = props?.data?.page;
    let message = '';

    switch(status) {
    case 404:
        message = page?.heading404 || '404 - Page not found.';
        break;
    case 500:
        message = page?.heading500 || '500 - Internal Server Error';
        break;
    default:
        message = 'Sorry, something went wrong.';
    }

    return (
        <>
            <Background />

            {/* Navigation */}
            <Header navigation={props.data?.navigation}/>

            <main
                className='pt-40 sm:pt-50 md:pt-100 min-h-screen relative'
                id='main-content'>
                <SideLine/>

                <div className='layout-container'>
                    <div className='flex flex-wrap layout-negative-margin'>
                        {/* Standfirst */}
                        <div className='sm:w-9/12 layout-item-padding mb-20'>
                            <h1 className='type-style-3'>
                                {message}
                            </h1>
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            {props.data?.footer && (
                <Footer {...props.data?.footer} />
            )}
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.object,
    err: PropTypes.object
};

ErrorPage.propTypes = propTypes;

export default ErrorPage;
